var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM9 3.9C9.59334 3.9 10.1734 4.07595 10.6667 4.40559C11.1601 4.73524 11.5446 5.20377 11.7716 5.75195C11.9987 6.30013 12.0581 6.90333 11.9424 7.48527C11.8266 8.06721 11.5409 8.60176 11.1213 9.02132C10.7018 9.44088 10.1672 9.7266 9.58527 9.84236C9.00333 9.95811 8.40013 9.8987 7.85195 9.67164C7.30377 9.44458 6.83524 9.06006 6.50559 8.56671C6.17595 8.07336 6 7.49334 6 6.9C6 6.10435 6.31607 5.34129 6.87868 4.77868C7.44129 4.21607 8.20435 3.9 9 3.9ZM9 11.8C11 11.8 15 12.89 15 14.88C14.3432 15.8701 13.4516 16.6823 12.4047 17.2442C11.3578 17.806 10.1881 18.1 9 18.1C7.81186 18.1 6.64218 17.806 5.59527 17.2442C4.54836 16.6823 3.65677 15.8701 3 14.88C3 12.89 7 11.8 9 11.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.fa657af7fb2085ae19fd1b849c57c5c4.svg";
export { ForwardRef as ReactComponent };